module.exports = __webpack_public_path__ + "img/bj.0fa69215.jpg";